module.exports = __webpack_public_path__ + "static/Krish_Resume_6:28:22-2ad0055934b1c6c1030ef6b1e93e29eb.pdf";